import http from "../http-common";

class EvaluationService {
    getevas() {
        return http.get('/evaluation');
    }
    geteva(id) {
        return http.get('/evaluation/' + id);
    }
    createeva(data) {
        return http.post('/evaluation', data);
    }
    updateeva(id, data) {
        return http.put(`/evaluation/${id}`, data);
    }
    getevainv(name) {
        return http.get('/evaluation/getevainv?name='+name);
    }
    getevaioff(name) {
        return http.get('/evaluation/getevaoff?name='+name);
    }
    deleteeva(id) {
        return http.delete('/evaluation/' + id);
    }
    getevainvreport(startdate,enddate,headerId) {
        return http.get('/evaluation/getevainvreport?startdate='+startdate+"&&enddate="+enddate+"&&headerId="+headerId);
    }
    getevaoffreport(startdate,enddate,headerId) {
        return http.get('/evaluation/getevaoffreport?startdate='+startdate+"&&enddate="+enddate+"&&headerId="+headerId);
    }
}

export default new EvaluationService();